import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isFetching: false,
    isFetchingCount: false,
    error: null,
    data: [],
    headers: [],
    count: 0,
    keys: [],
    document_category: [],
    document_type: [],
};

/**
 * 詳細検索Reducer
 */
const detailSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ---------------------------------------------
     * リクエスト開始
     * --------------------------------------------- */
    case ActionTypes.FETCH_DETAIL_SEARCH_REQUEST:
        return {
            ...state,
            isFetching: true,
            error: null,
        };

    /* ---------------------------------------------
     * リクエスト成功
     * --------------------------------------------- */
    case ActionTypes.FETCH_DETAIL_SEARCH_SUCCESS:
        return {
            ...state,
            isFetching: false,
            error: null,
            data: action.payload.data || [],
            headers: action.payload.headers || [],
        };

    /* ---------------------------------------------
     * リクエスト失敗
     * --------------------------------------------- */
    case ActionTypes.FETCH_DETAIL_SEARCH_FAILURE:
        return {
            ...state,
            isFetching: false,
            error: action.payload,
        };

        case ActionTypes.FETCH_DETAIL_SEARCH_COUNT_REQUEST:
      return { ...state, isFetchingCount: true, error: null };

    case ActionTypes.FETCH_DETAIL_SEARCH_COUNT_SUCCESS:
        return {
            ...state,
            isFetchingCount: false,
            count: action.payload.count,
            keys: action.payload.keys || [],
        };

    case ActionTypes.FETCH_DETAIL_SEARCH_COUNT_FAILURE:
        return { ...state, isFetchingCount: false, error: action.payload };

    case "CLEAR_DETAIL_SEARCH":
        return {
            ...state,
            data: [],
            headers: [],
            count: 0,
        };

    case ActionTypes.FETCH_DATA_TYPE_REQUEST:
        return { ...state, isFetching: true, error: null };
    case ActionTypes.FETCH_DATA_TYPE_SUCCESS:
        return {
            ...state,
            document_category: action.payload.document_category || [],
            document_type: action.payload.document_type || [],
            isFetching: false,
        };
    case ActionTypes.FETCH_DATA_TYPE_FAILURE:
        return { ...state, isFetching: false, error: action.payload };
    /* ---------------------------------------------
     * デフォルト
     * --------------------------------------------- */
    default:
      return state;
  }
};

export default detailSearchReducer;
